<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="printRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="props" :vm-active="isModalPropVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(v-model="props" label='Atención a:')

</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseRequisitions')

export default {
  name: 'ModalPurchaseRequisitionsProp',
  props: {
    title: {
      type: String,
      default: 'Imprimir Orden de Compra'
    },
    id: {
      type: Number
    },
    props: {
      type: String
    }
  },
  computed: {
    ...mapGetters([
      'isModalPropVisible'
    ])
  },
  methods: {
    ...mapActions([
      'printReportRecord',
      'setModalPropVisible'
    ]),
    printRecord () {
      this.printReportRecord({ id: this.id, props: this.props })
    },
    close () {
      this.setModalPropVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
